module.exports = __webpack_public_path__ + "static/media/sd.15c4a758.svg";